import { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

// 1. Create query client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60, // 10 minutes
      cacheTime: 1000 * 60 * 60, // 30 minutes
    },
  },
});

// 2. Create persister (localStorage)
const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

// 3. Connect persistence
persistQueryClient({
  queryClient,
  persister,
  maxAge: 1000 * 60 * 60 * 24, // 24 hours
});